import restCrudReducer from '../../../np-crud/store/restCrudReducer';

const [crudInitialState, crudReducer] = restCrudReducer({
    pluginName: 'IMPORT_EXPORT',
    entityName: 'SECURAZE_TOOLS',
});

const initialState = {
    ...crudInitialState,
    deleteSecurazeTool: {},
    deleting: false,
    saving: false,
    progress: null,
    snackBar: false,
    snackStart: false
};

const reducer = (state = initialState, action) => {
    // Handle CRUD actions
    const newState = crudReducer(state, action);
    // If CRUD reducer handled the action
    if (newState !== null) {
        return newState;
    }
    // Handle other actions
    switch (action.type) {
        case 'CORE|LOGOUT_SUCCESS':
        case 'CORE|CORE_SET_ACTIVE_CUSTOMER_SUCCESS':
            return initialState;
        case 'SECURAZE_TOOLS|PROGRESS':
            return { ...state, progress: action.progress, maxSize: action.maxSize, loadSize: action.loadSize, snackStart: action.snackStart };
        case 'CLEAR_STATE_CREATE':
            return { ...state, progress: null, maxSize: null, loadSize: null, snackStart: false };
        default:
            return state;
    }
};

export default reducer;
